// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'

const HeadlineReservationWrapper = styled.div`
  text-align: left;
`
const PageTitle = styled.h1`
  font-size: ${fontSize.medium_2}px;
  color: ${Colors.black};
  font-weight: bold;
  line-height: 1.333;
  ${mediaMin.phone`
    font-size: ${fontSize.large}px;
  `};
`
const Pre = styled.pre`
  white-space: pre-wrap;
`
const LeadText = styled.pre`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1.4;
  white-space: pre-wrap;
  ${mediaMin.phone`
    margin-top: ${spacing.small_3}px;
  `};
`
const LeadBack = styled.div`
  display: block;
  font-size: ${fontSize.small_2}px;
  margin-top: ${spacing.small_3}px;
  &:hover {
    text-decoration: underline;
  }
`
const LeadBackLink = styled.a`
  color: ${Colors.blue};
  position: relative;
  padding-left: ${spacing.small_2}px;
  &::before {
    content: '';
    width: 5px;
    height: 5px;
    border-top: 2px solid ${Colors.blue};
    border-left: 2px solid ${Colors.blue};
    transform: translate(0, -50%) rotate(-45deg);
    position: absolute;
    top: 50%;
    left: 0;
  }
`
const SpBr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`

export type PropTypes = {
  title: string | Array<string>,
  children: any,
  href?: string,
  linkText?: string,
  onClick?: ?Function,
}

export default function HeadlineReservation(props: PropTypes) {
  return (
    <HeadlineReservationWrapper>
      {Array.isArray(props.title) ? (
        <PageTitle>
          <Pre>
            {props.title.map((text, i) => (
              <Fragment key={`title_text_${i}`}>
                {text}
                <SpBr />
              </Fragment>
            ))}
          </Pre>
        </PageTitle>
      ) : (
        <PageTitle>
          <Pre>{props.title}</Pre>
        </PageTitle>
      )}
      <LeadText>{props.children}</LeadText>
      {props.href && (
        <LeadBack>
          <LeadBackLink href={props.href} onClick={props.onClick}>
            {props.linkText}
          </LeadBackLink>
        </LeadBack>
      )}
    </HeadlineReservationWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/HeadlineReservation/index.jsx